import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useLocalization } from '../../../contexts/localization-context';

const ButtonRouterLink = (
  {
    ariaLabel,
    children,
    className,
    classNameCustom,
    onClick,
    style,
    target,
    text,
    textClassName,
    to,
  },
) => {
  const { getLocalization } = useLocalization();

  return (
    <Link
      aria-label={getLocalization(ariaLabel)}
      className={`${className} ${classNameCustom}`}
      onClick={() => {
        onClick();
      }}
      style={style}
      target={target}
      to={to}
    >
      {children}
      {text && <span className={textClassName || 'button__text'}>{getLocalization(text)}</span>}
    </Link>
  );
};

ButtonRouterLink.defaultProps = {
  ariaLabel: '',
  className: 'button',
  classNameCustom: '',
  onClick: () => {},
  style: {},
  text: null,
  textClassName: '',
};

ButtonRouterLink.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  classNameCustom: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  text: PropTypes.string,
  textClassName: PropTypes.string,
  to: PropTypes.any.isRequired,
};

export default ButtonRouterLink;
